export default __webpack_public_path__ + "static/media/alert-circle.15e22335.svg";